<div class="convenience-fee-box">
    <p class="convenience-fee-text"><span> Convenience fee of <strong class="text-style-1"> {{getpayUConvenienceFee()
                | currency:'INR':'symbol':'2.2'}}
            </strong> (Incl of {{payUConvenienceFeeGSTPercentage}}% GST) </span>
        <span> <strong class="text-style-1">waived off by Finzy </strong></span>
        <app-tooltip placement="bottom">
            <i class="fa fa-info-circle text-style-1 info-icon" trigger></i>
            <div content style="width: 35vw; max-width: 250px">
                <div class="row p-0 m-0">
                    <p class="col-xs-12">
                        The waiver of convenience fee is for a limited period and subject to change after <strong>March
                            31st 2022</strong>
                    </p>
                </div>
            </div>
        </app-tooltip>
    </p>
</div>

<div class="debit-card-container">

    <div class="enter-card-details">
        <p>Enter the card details</p>
    </div>
    <div class="coming-soon-message">
        <span>We accept: </span> 
        <img class="coming-soon-logo-visa" src="../../../assets/images/payment-collection/visa-coming-soon-logo.png">
        <img class="coming-soon-logo-rupay" src="../../../assets/images/payment-collection/ru-pay-coming-soon-logo.png">
        <span class="coming-soon-text">  Coming soon:  </span>
        <img class="coming-soon-logo-master" src="../../../assets/images/payment-collection/mastercard-logo-coming-soon.png">
    </div>

    <form [formGroup]="debitCardForm">

        <div class="row">
            <mat-form-field class="col-xs-12 card-holder-name-wrapper">
                <input class="card-holder-name" type="text" matInput formControlName="cardHolderName" name="ccname"
                    placeholder="Name on the Card"
                    [(ngModel)]="paymentRequest.paymentDetails.cardDetails.cardHolderName">
                <mat-error class="error-message">
                    {{ getErrorMessage(debitCardForm.controls.cardHolderName) }}
                </mat-error>
            </mat-form-field>
        </div>

        <div class="row">
            <mat-form-field class="col-xs-12 card-number-wrapper">
                <input class="card-number" type="text" matInput formControlName="cardNumber" name="ccnum"
                    placeholder="Card Number" [(ngModel)]="cardNumberWithSpace" debit-card
                    (ngModelChange)="onCardNumberChange()" [class.master-card]="isMasterCard"
                    onKeyPress="if(this.value.length==25) return false;" [class.visa-card]="isVisaCard"
                    [class.ru-pay-card]="isRuPayCard">
                <mat-error class="error-message">
                    {{ getErrorMessage(debitCardForm.controls.cardNumber) }}
                </mat-error>
            </mat-form-field>
        </div>

        <div class="row">
            <div formGroupName="cardDateValidityForm">
                <mat-form-field class="col-xs-12 col-sm-4 card-month-year-wrapper">
                    <mat-select class="card-month-year" formControlName="cardExpiryMonth" placeholder="Expiry Month"
                        (ngModelChange)="onDateChange()">
                        <mat-option *ngFor="let month of months" [value]="month.value">{{month.displayName}}
                        </mat-option>
                    </mat-select>
                    <mat-error class="error-message">
                        {{ getErrorMessage(debitCardForm.get('cardDateValidityForm').get('cardExpiryMonth'))}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="col-xs-12 col-sm-4 card-month-year-wrapper">
                    <mat-select class="card-month-year" formControlName="cardExpiryYear" placeholder="Expiry Year"
                        (ngModelChange)="onDateChange()">
                        <mat-option *ngFor="let year of years" [value]="year.value">{{year.displayName}}</mat-option>
                    </mat-select>
                    <mat-error class="error-message">
                        {{ getErrorMessage(debitCardForm.get('cardDateValidityForm').get('cardExpiryYear'))}}
                    </mat-error>
                </mat-form-field>
            </div>

            <mat-form-field class="col-xs-12 col-sm-4 card-cvv-wrapper">
                <div class="row">
                    <div class="col-xs-10">
                        <input class="card-cvv" type="password" matInput formControlName="cardCVV" name="ccvv"
                            placeholder="CVV" [(ngModel)]="paymentRequest.paymentDetails.cardDetails.cardCVV"
                            onKeyPress="if(this.value.length==3) return false;">
                    </div>
                    <div class="col-xs-2">
                        <app-tooltip placement="left">
                            <i class="fa fa-info-circle" trigger></i>
                            <div content style="width: 30vw; max-width: 200px">
                                <div class="row p-0 m-0">
                                    <p class="col-xs-12">
                                        The CVV is a 3 digits number on the back of your card
                                    </p>
                                </div>
                            </div>
                        </app-tooltip>
                    </div>
                </div>

                <mat-error class="error-message">
                    {{ getErrorMessage(debitCardForm.controls.cardCVV) }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <div class="col-sm-12 remember-card-wrapper">
                <mat-checkbox formControlName="rememberCard" name="rememberCard"
                    [(ngModel)]="paymentRequest.paymentDetails.cardDetails.rememberCard">
                    <p class="remember-card"> Save this Card securely for faster payment</p>
                </mat-checkbox>
            </div>
        </div>

    </form>

</div>